import { render, staticRenderFns } from "./AvailableLaboursMain.vue?vue&type=template&id=331fe240"
import script from "./AvailableLaboursMain.vue?vue&type=script&lang=js"
export * from "./AvailableLaboursMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331fe240')) {
      api.createRecord('331fe240', component.options)
    } else {
      api.reload('331fe240', component.options)
    }
    module.hot.accept("./AvailableLaboursMain.vue?vue&type=template&id=331fe240", function () {
      api.rerender('331fe240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableLaboursMain.vue"
export default component.exports